// extracted by mini-css-extract-plugin
module.exports = {"logoSection":"LogoSection_logoSection__IGutc"};